import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Observable } from 'rxjs';
import * as data from 'src/assets/data.json';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  public headers: string[] = [];
  public row: { [key: string]: string; } = {};
  public patientId: string = '';
  public imgSrc = ""
  public sub: any;
  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.sub = this.route.params.subscribe((params:any) => {
      this.patientId = params.id;
      let record: { [key: string]: any; } =  data.data.find(x => x.info.Id == this.patientId)!!
      this.headers = Object.keys(record.info)
      for(let i=0; i< this.headers.length; i++){
        this.row[this.headers[i]] = record.info[this.headers[i]]
      }
      this.imgSrc = '../assets/pictures/'.concat(record.main_picture)
    });   
  }
  

}
